import { Box, Grid2 as Grid, Typography } from '@mui/material';

import MobileContentBG from '../../assets/mobileContentBG.png';
import PlayGroundImg from '../../assets/playground.png';
import React from 'react';
import content_Bg from '../../assets/ContentBG.webp';

interface TalentProps {
  isMobile?: Boolean | null;
}

const Talent: React.FC<TalentProps> = ({ isMobile }) => {
  return (
    <Box
      sx={{
        position: 'relative',
        overflow: 'hidden'
      }}>
      <Grid container justifyContent="center" alignItems="center">
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          size={{ xs: 12, md: 8 }}
          sx={{ display: { xs: 'none', md: 'flex' } }}>
          <Box p={6}>
            <Typography
              style={{
                fontFamily: 'Bevan',

                fontSize: '48px',
                lineHeight: '1'
              }}>
              <span style={{ color: 'white' }}>{`“ `}</span>
              <span
                style={{
                  background: 'linear-gradient(232.05deg, #FFDD01 19.84%, #FFB82A 92.22%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent'
                }}>
                {` Your Playground for`}
              </span>
            </Typography>
            <Typography
              style={{
                fontFamily: 'Bevan',
                background: 'linear-gradient(232.05deg, #FFDD01 19.84%, #FFB82A 92.22%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                fontSize: '48px'
              }}>
              {`Imagination - Dream,`}
            </Typography>
            <Typography
              style={{
                fontFamily: 'Bevan',
                fontSize: '48px'
              }}>
              <span
                style={{
                  background: 'linear-gradient(232.05deg, #FFDD01 19.84%, #FFB82A 92.22%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent'
                }}>
                {`Create, and Transform! `}
              </span>

              <span style={{ color: 'white' }}>{`”`}</span>
            </Typography>
            <Typography
              sx={{
                fontFamily: 'Baloo2',
                color: '#fff',
                whiteSpace: 'pre-line',
                fontSize: '19px'
              }}>
              Paint it. Sing it. Write it. Act it. Sculpt it. Even invent it! Whether{'\n'}
              you&apos;re a solo genius or a team player, Champsverse gives you the
              {'\n'}
              freedom to create your own legacy. Every skill, every talent, every
              {'\n'}
              dream gets a stage.
            </Typography>
          </Box>
        </Grid>

        <Grid
          size={{ xs: 12, md: 8 }}
          sx={{
            display: { xs: 'block', md: 'none' },
            margin: '30px 0'
          }}>
          <Typography fontSize={20} fontWeight={800} fontFamily={'Bevan'} align="center">
            <span style={{ color: 'white' }}>{`“ `}</span>
            <span
              style={{
                background: 'linear-gradient(232.05deg, #FFDD01 19.84%, #FFB82A 92.22%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}>
              {`  Your Playground for`}
            </span>
          </Typography>

          <Typography
            fontSize={20}
            fontWeight={800}
            fontFamily={'Bevan'}
            align="center"
            sx={{
              background: 'linear-gradient(232.05deg, #FFDD01 19.84%, #FFB82A 92.22%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent'
            }}>
            Imagination - Dream,
          </Typography>
          <Typography fontSize={20} fontWeight={800} fontFamily={'Bevan'} align="center">
            <span
              style={{
                background: 'linear-gradient(232.05deg, #FFDD01 19.84%, #FFB82A 92.22%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}>
              {`Create, and Transform! `}
            </span>

            <span style={{ color: 'white' }}>{`”`}</span>
          </Typography>

          <Typography
            sx={{
              fontFamily: 'Baloo2',
              fontWeight: 500,
              fontSize: '15px',
              pt: '10px',
              color: 'white',
              textAlign: 'center',
              margin: '0 40px'
            }}>
            Champsverse isn’t just a platform—it’s a movement. A place where
            {'\n'}
            every child gets seen, heard, and valued. A world where creativity {'\n'}
            fuels success and effort never goes unnoticed!
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Box display="flex" justifyContent="center" alignItems="center">
            <img
              src={PlayGroundImg}
              alt="learning"
              style={{
                width: isMobile ? '305px' : 620,
                height: isMobile ? '305px' : 620
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
export default Talent;
